// extracted by mini-css-extract-plugin
module.exports = {"option":"style_option__dFQNB","paper":"style_paper__JB2E4"};